module.exports = __webpack_public_path__ + "img/Stack.e7a36796.svg";